var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"type":"submit","variant":"primary","disabled":_vm.disabled || !_vm.dirty,"form":_vm.form}},[_c('FontAwesomeIcon',{attrs:{"icon":_vm.saveIcon}}),_vm._v(" Save ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }